// Display placement, not a manufacturer hardware or accessibility specification.
export const HANDLE_HEIGHT_M = 39 * .0254;
export const handleHeight = panelHeight => Math.min(HANDLE_HEIGHT_M, Math.max(.2, panelHeight - .21));

export function slidingHandleSpec({ system, panelWidth, panelHeight, pocket = false, face = 1, panelIndex = 1 }) {
  const inset = system === 'SD150' ? .017 : .038;
  const surface = system === 'SD150' ? .02925 : .0275;
  return { system, panelIndex, pocket, face, inset, surface,
    x: panelWidth / 2 - inset, y: handleHeight(panelHeight),
    edge: 'closing-stile', type: pocket ? 'flush-pull' : 'supported-pull',
  };
}